import React from 'react'
import _ from 'lodash'
import {message} from 'antd'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import LookupField from 'components/LookupField'
import {organization_createGroup_Api} from 'apis/organization'

// "parish_zone" - group_type riêng cho khu vực nội bộ giáo xứ (Common::$familyBookZoneGroupType,
// xem 080_add_zone_to_family_books.sql). Group owner = CHÍNH org giáo xứ (organizationId truyền
// vào), dùng lại NGUYÊN hệ Groups có sẵn (docs/architecture/groups.md) - Kitô Vua/Thánh Giuse/Mẹ
// Fatima... là các Group thật, KHÔNG phải chuỗi tự do rời rạc.
export const ZONE_GROUP_TYPE = 'parish_zone'

// LookupField gốc (createIfNotExists) mặc định CHỈ tạo 1 giá trị "keyword" cục bộ (id rỗng, xem
// components/form/utils.js createValue()) - đúng cho field kiểu "tên tự do + gợi ý" (matrimony
// parish...), nhưng Giáo khu cần 1 Group THẬT (để lọc/thống kê theo id chuẩn, không lệch chính tả
// giữa các lần gõ). Wrapper này chặn đúng nhánh "chưa có id" (vừa gõ từ khoá mới) -> gọi
// organization_createGroup_Api tạo Group thật trước, rồi mới trả value có id thật ra ngoài qua
// onChange - các lựa chọn CÓ SẴN (đã có id) đi thẳng, không qua bước tạo.
const ZoneLookupField = ({organizationId, value, onChange, t}) => {
    const {handleAsyncAction: doCreateZone, loading: creating} = useAsyncAction({
        apiInfo: organization_createGroup_Api,
        onSuccess: (result, {response}) => {
            const created = _.get(response, 'data')
            if (created?.id) onChange({id: created.id, value: created.title})
        },
        onError: () => message.error(t('error occurred')),
    })

    return (
        <LookupField
            name="parish_zone"
            title={t('choose or create zone')}
            apiPath={`/organizations/${organizationId}/get-groups?group_type=${ZONE_GROUP_TYPE}`}
            placeholder={creating ? t('creating') : t('choose or create zone')}
            disabled={creating}
            createIfNotExists
            defaultValue={value?.value}
            selectedOption={value}
            handleChange={(e) => {
                const target = e.target
                if (!target?.value) {
                    onChange(null)
                } else if (target.id) {
                    onChange({id: target.id, value: target.value || target.label})
                } else {
                    // Gõ từ khoá mới, chưa khớp Group nào có sẵn - tạo Group thật trước (title = từ
                    // khoá vừa gõ), value cuối cùng chỉ được set trong onSuccess ở trên khi đã có id
                    // thật, tránh lưu 1 "zone" không tồn tại record nào.
                    doCreateZone({title: target.value, group_type: ZONE_GROUP_TYPE}, {id: organizationId})
                }
            }}
        />
    )
}

export default ZoneLookupField
